export default "__VITE_ASSET__d3372bed__"